<template>
  <DialogDrawer
    ref="dialog"
    data-testid="portfolio.delete-dialog"
    modal
    placement="centre"
    @close="$emit('close')"
    @submit="$emit('delete', props.type)"
  >
    <template #title> Are you sure you wish to delete this item? </template>
    <template #buttons>
      <BootstrapButton name="cancel" variant="ghost" formmethod="dialog" @click="$emit('close')">
        Cancel
      </BootstrapButton>
      <BootstrapButton :loading="loading" variant="danger" type="submit" name="delete">
        Delete
      </BootstrapButton>
    </template>
  </DialogDrawer>
</template>
<script setup lang="ts">
import DialogDrawer from '@/components/shared/custom/DialogDrawer/DialogDrawer.vue';

const props = defineProps<{
  type?: string;
  open: boolean;
  loading?: boolean;
}>();

defineEmits<{
  close: [];
  delete: [string?];
}>();

const dialog = useTemplateRef<InstanceType<typeof DialogDrawer>>('dialog');

watch(
  () => props.open,
  (newOpen) => {
    if (newOpen) {
      dialog.value?.openModal();
    } else {
      dialog.value?.close();
    }
  },
);
</script>
